
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { WebsiteNotificationsRequest, WebsiteNotificationsResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<WebsiteNotificationsResponse, WebsiteNotificationsResponse>) => response?.data;
const getError = (response?: SWRResponse<WebsiteNotificationsResponse, WebsiteNotificationsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<WebsiteNotificationsResponse, WebsiteNotificationsResponse>) => ({});

const useGetWebsiteNotifications = (query?: Partial<WebsiteNotificationsRequest>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new WebsiteNotificationsRequest(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetWebsiteNotifications;